import type { ReactNode } from 'react';
import { Markdown } from '@/shared/ui/markdown/Markdown';

type Props = {
  /** メッセージ左肩のアバター（事業チャットはフォルダ、汎用チャットはCpuChip等） */
  avatar: ReactNode;
  /** Markdown としてレンダリングする本文 */
  content: string;
  /** 本文下のアクション行（コピー・サムズ・参照情報等）。コンテキストごとに自由に指定する */
  actions?: ReactNode;
};

/** AI 応答メッセージの共通レイアウト（アバター + Markdown + アクション行）。 */
export const AssistantMessageLayout = ({ avatar, content, actions }: Props) => {
  return (
    <div className="flex flex-col gap-2">
      {avatar}
      <Markdown>{content}</Markdown>
      {actions && <div className="flex items-center gap-1">{actions}</div>}
    </div>
  );
};
